import React from 'react';
import Menu from './menu';
import imagemLogo from '../../assets/images/sologo_infinitum_azul.png';
import MenuPerfilAcesso from './menuPerfilAcesso';

export default props => (
	<aside className="main-sidebar elevation-4 sidebar-light-indigo">
		<a href="../../" className="brand-link navbar-light" 
			style={{
				height: 51
			}}>
			<img src={imagemLogo} alt="Portal Infinitum" 
				className="brand-image" 
				style={{ 
					marginTop: -3,
					marginRight: 0
				}} />
			<div style={{ display: 'flex', flexDirection: 'column', marginTop: 0 }}>
				<span className="brand-text" 
					style={{
						fontWeight: '500',
						fontSize: 16,
						marginLeft: 8,
						letterSpacing: 1,
						color: '#rgb(56, 66, 86)'
					}}>Portal Infinitum</span>
			</div>
		</a>
		<div className="sidebar">
			<MenuPerfilAcesso />
		</div>
	</aside>
)
